import React from 'react';
interface FieldProps {
  id: string;
  label: string;
  hint?: string;
  error?: string;
  required?: boolean;
  children: React.ReactNode;
}
export function Field({
  id,
  label,
  hint,
  error,
  required,
  children
}: FieldProps) {
  return <div data-id="element-1325" data-mp="3v73eaobmzb89">
      <label htmlFor={id} className="block text-[14px] font-medium text-ink" data-id="element-1326" data-mp="3v7d5ugcbxqg2">
        {label}
        {!required && <span className="ml-1.5 font-normal text-muted" data-id="element-1327" data-mp="40aenowhrk5u">optional</span>}
      </label>
      {hint && <p id={`${id}-hint`} className="mt-1 text-small text-muted" data-id="element-1328" data-mp="8znbn2h2u7m5">
          {hint}
        </p>}
      <div className="mt-2" data-id="element-1329" data-mp="d0p1isp3t7bg">{children}</div>
      {error && <p id={`${id}-error`} role="alert" className="mt-2 text-small text-[#FF8B7A]" data-id="element-1330" data-mp="hubgiriqpnaf">
          {error}
        </p>}
    </div>;
}

// Fields sit on navy panels, so the control is a darker well rather than a white
// box: white behind near white heading text left the value unreadable.
export const inputClass = 'w-full rounded-sm border border-line bg-charcoal px-3.5 py-2.5 text-[15px] text-ink placeholder:text-muted focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold';
interface ConsentCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
}
export function ConsentCheckbox({
  id,
  checked,
  onChange,
  children
}: ConsentCheckboxProps) {
  return <div className="flex items-start gap-3" data-id="element-1331" data-mp="ke109sblttfq">
      <input id={id} type="checkbox" checked={checked} onChange={event => onChange(event.target.checked)} className="mt-1 h-4 w-4 shrink-0 rounded-[2px] border-line text-royal accent-[#FF5C1A]" data-id="element-1332" data-mp="1h0vzyc3ch81b" />
      <label htmlFor={id} className="text-[13px] leading-relaxed text-body" data-id="element-1333" data-mp="179rkzcdo5n6h">
        {children}
      </label>
    </div>;
}